import { styled } from '@mui/material/styles';
// material
import { Box, Typography, Container } from '@mui/material';
// components
import Page from '../../components/Page';

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  display: 'flex',
  minHeight: '100%',
  alignItems: 'center',
  paddingTop: theme.spacing(15),
  paddingBottom: theme.spacing(10)
}));

// ----------------------------------------------------------------------

export default function SomethingWentWrongPage() {
  return (
    <RootStyle title="Something Went Wrong">
      <Container>
        <Box sx={{ maxWidth: 480, margin: 'auto', textAlign: 'center' }}>
          <Typography variant="h3" paragraph>
            Something Went Wrong
          </Typography>
          <Typography sx={{ color: 'text.secondary' }}>
            An unexpected error occured, the application will reload.
          </Typography>
        </Box>
      </Container>
    </RootStyle>
  );
}
